module.exports = __webpack_public_path__ + "static/img/logo-if-dm.1e5c00bb.svg";